<template>
  <div class="detail"> 
    <div class="container">
      <div @click="goToBack()" class="img-box">
        <img src="../assets/image/left.png">
      </div>
      <p v-html="detail.content"></p>  
    </div>
  </div>
</template>

<script>
import { requestUserDetail} from '@/http/index';
  export default {
    name: 'userDetail',
    data(){
      return {
        detail: {}
      }
    },
    mounted(){
      console.log('detail-mounted')
      this.queryUserDetail()
    },
    activated(){
      console.log('detail-activated')
      this.queryUserDetail();
    },
    methods: {
      queryUserDetail(){
        requestUserDetail({ id: this.$route.query.id }).then(res => {
          this.detail = res.data
        })
      },
      goToBack(){
        this.$router.back()
      }
    }
  }
</script>

<style lang="scss" scoped>
.detail {
  background: linear-gradient(0deg, #2165FF 0%, #7CD9FF 100%);
  // min-height: 100%;
  // min-height: calc(100% - env(safe-area-inset-bottom));
  height: 100%;
  overflow: auto;
  .container {
    width: 92vw;
    margin: 4.8vw auto 4.8vw;
    background: white;  
    border-radius: 2.66666667vw;
    .img-box {
      position: absolute;
      top: 8vw;
      left: 8vw;
      img {
        width: 8vw;
      }
    }
    p {
      padding: 0 4.666667vw 3vw;
    }
  }
}

</style>  